{#key formattedDate}
    <span class="prom-relative-date">{formattedDate}</span>
{/key}

<script>
    import { formatDate, getIntervalType, dateIntervals } from './dateHelpers';

    /** @type {Date} */
    export let date = undefined;

    export let locale = 'en-US';

    export let timeZone = undefined;

    /** @type {Boolean} */
    export let twelveHourFormat = undefined;

    export let i18n = {
        nDaysAgo: '{0} days ago',
        week: '{0} at {1}',
        oneDayAgo: 'yesterday at {0}',
        oneHourAgo: 'one hour ago',
        nHoursAgo: '{0} hours ago',
        oneMinuteAgo: 'one minute ago',
        nMinutesAgo: '{0} minutes ago',
        justNow: 'just now',

        day0: 'Sunday',
        day1: 'Monday',
        day2: 'Tuesday',
        day3: 'Wednesday',
        day4: 'Thursday',
        day5: 'Friday',
        day6: 'Saturday'
    }

    /** @type {String} */
    let formattedDate;

    let timerId;

    $: {
        formattedDate = getFormattedDate(date);
        setTimer();
    }

    function setTimer() {
        if (timerId) {
            clearTimeout(timerId);
            timerId = undefined;
        }
        if (!date) {
            return;
        }
        const intervalType = getIntervalType(date);
        let interval;
        switch (intervalType) {
            case 'second':
            case 'minute':
                interval = dateIntervals.minute * 1000;
                break;
            case 'hour':
                interval = dateIntervals.hour * 1000;
                break;
        }
        if (interval) {
            timerId = setTimeout(() => {
                formattedDate = getFormattedDate(date);
                setTimer();
            }, interval);
        }
    }

    function getFormattedDate(date) {
        return date 
            ? formatDate(date, locale, timeZone, twelveHourFormat, i18n)
            : '';
    }
</script>